(ns common.lead-types
  (:require [common.util :as cu]))

(defonce options [{:key   :inbound
                   :label "Inbound"}
                  {:key   :outbound
                   :label "Outbound"}
                  {:key   :referred
                   :label "Referred"}])

(def get-key (partial cu/get-key options))

(def get-label (partial cu/get-label options))
